import axios from "axios";
import dayjs from "dayjs";  

export const fetchOeeDashboardDataTimeSpan = async (timeSpan,companyKey) => {
    const response = await axios.get("api/oeegrid/getoeetimespan/"+companyKey+"?timeSpan="+timeSpan);
    const oeeDashboardData = response.data;

    if (!Array.isArray(oeeDashboardData)) {
        console.warn("Bad API response in fetchOeeDashboardDataTimeSpan", oeeDashboardData);
        return [];
    }

    return oeeDashboardData;
}

export const fetchOeeGridDateIntervall = async(startDate,endDate,companyKey) => {
    const response = await axios.get("api/oeegrid/getoeedateintervall/"+companyKey+"?startDate="+dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS")+"&endDate="+dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS"));
    const oeeGridData = response.data;
    
    if (!Array.isArray(oeeGridData)) {
        console.warn("Bad API response in fetchOeeGridDateIntervall", oeeGridData);
        return [];
    }

    return oeeGridData;
}

export const updateMachinePriority = async (priority) => {
    return await axios.post(`api/api/updateMachinePriority/${priority.machineName}`,priority);
}

export const fetchWorkOrderComment = async(companyKey) => {
    const response = await axios.get("api/api/getworkordercomment/"+companyKey);
    const workOrderComment = response.data;
    
    if (!Array.isArray(workOrderComment)) {
        console.warn("Bad API response in fetchWorkOrderComment", workOrderComment);
        return [];
    }

    return workOrderComment;
}

export const updateWorkOrderComment = async (comment) => {
    return await axios.post(`api/api/updateWorkOrderComment`,comment);

}